var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%","display":"flex","justify-content":"center","align-items":"center"}},[_c('img',{attrs:{"src":require('@/assets/images/404.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }